(() => {
  'use strict';
  const configElement = document.getElementById('bb-store-config');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const drawer = document.getElementById('bb-cart-drawer');
  let cartBusy = false;
  const cartUrl = config.root + 'cart';
  const renderCart = html => {
    if (!html || !drawer) return false;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const content = parsed.getElementById('bb-drawer-content');
    if (!content) return false;
    drawer.replaceChildren(content);
    document.querySelectorAll('[data-cart-count]').forEach(c => c.textContent = content.dataset.count);
    return true;
  };
  const refreshCart = async () => {
    const response = await fetch(config.root + '?sections=bb-footer', {headers:{Accept:'application/json'},cache:'no-store'});
    if (!response.ok) throw new Error('cart');
    const sections = await response.json();
    if (!renderCart(sections['bb-footer'])) throw new Error('cart');
  };
  const openCart = () => { if (drawer && !drawer.open) drawer.showModal(); };
  const setCartBusy = state => {
    cartBusy = state;
    if (!drawer) return;
    drawer.setAttribute('aria-busy', String(state));
    drawer.querySelectorAll('[data-cart-key],button[name="checkout"]').forEach(b => b.disabled = state);
  };
  const cartError = () => {
    const error = drawer?.querySelector('[data-cart-error]');
    if(error){error.textContent=document.documentElement.lang.startsWith('nl')?'Bijwerken lukt nu niet. Probeer het opnieuw of open je winkelwagen.':'Unable to update. Try again or open your shopping bag.';error.hidden=false;}
  };
  if(drawer){
    drawer.addEventListener('click', async event => {
      if(event.target === drawer){const r=drawer.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)drawer.close();return;}
      if(event.target.closest('[data-cart-close]')){drawer.close();return;}
      const button=event.target.closest('[data-cart-key]');
      if(!button||cartBusy)return;
      const key=button.dataset.cartKey, quantity=Number(button.dataset.quantity);
      setCartBusy(true);
      try{
        const response=await fetch(config.root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity,sections:['bb-footer'],sections_url:config.root})});
        const data=await response.json();
        if(!response.ok)throw new Error(data.description||'cart');
        if(!renderCart(data.sections?.['bb-footer']))await refreshCart();
        const target=Array.from(drawer.querySelectorAll('[data-cart-key]')).find(b=>b.dataset.cartKey===key);
        (target||drawer.querySelector('[data-cart-close]'))?.focus();
      }catch{cartError();}finally{setCartBusy(false);}
    });
    document.querySelectorAll('[data-cart-open]').forEach(link=>link.addEventListener('click',async event=>{
      if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
      event.preventDefault();openCart();if(cartBusy)return;setCartBusy(true);
      try{await refreshCart();}catch{cartError();}finally{setCartBusy(false);}
    }));
  }
  document.querySelectorAll('[data-auto-submit]').forEach(select=>select.addEventListener('change',()=>select.form.requestSubmit()));
  const gallery=document.querySelector('[data-gallery]');
  let showGalleryImage=()=>{};
  if(gallery){
    const track=gallery.querySelector('[data-gallery-track]'),slides=Array.from(track.children),thumbs=Array.from(gallery.querySelectorAll('[data-gallery-index]'));
    const counter=gallery.querySelector('[data-gallery-count]'),prev=gallery.querySelector('[data-gallery-prev]'),next=gallery.querySelector('[data-gallery-next]');
    const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
    let index=0,frame;
    const fitImage=()=>{const image=slides[index]?.querySelector("img");if(!image)return;const width=Number(image.getAttribute("width"))||image.naturalWidth;const height=Number(image.getAttribute("height"))||image.naturalHeight;if(width>0&&height>0)track.style.setProperty("--bb-image-ratio",`${width} / ${height}`);};
    slides.forEach(slide=>slide.querySelector("img")?.addEventListener("load",fitImage));
    const sync=()=>{index=Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/track.clientWidth)));thumbs.forEach((t,i)=>t.setAttribute('aria-pressed',String(i===index)));if(counter)counter.textContent=`${index+1} / ${slides.length}`;if(prev)prev.disabled=index===0;if(next)next.disabled=index===slides.length-1;fitImage();};
    const show=i=>{i=Math.max(0,Math.min(slides.length-1,i));track.scrollTo({left:i*track.clientWidth,behavior:reduced?'auto':'smooth'});};
    thumbs.forEach((t,i)=>t.addEventListener('click',()=>show(i)));
    prev?.addEventListener('click',()=>show(index-1));next?.addEventListener('click',()=>show(index+1));
    track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(sync);},{passive:true});
    track.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();show(index+(e.key==='ArrowRight'?1:-1));}});
    showGalleryImage=id=>{const i=slides.findIndex(s=>s.dataset.imageId===String(id));if(i>=0)show(i);};
    sync();
  }
  const form=document.getElementById('bb-product-form'),variant=document.getElementById('bb-variant');
  let submitting=false;
  const buttons=()=>Array.from(document.querySelectorAll('[data-add-button]'));
  const updateVariant=()=>{
    if(!variant)return;
    const option=variant.selectedOptions[0],available=option.dataset.available==='true';
    if(option.dataset.imageId)showGalleryImage(option.dataset.imageId);
    document.querySelectorAll('[data-product-price]').forEach(p=>p.textContent=option.dataset.price);
    document.querySelectorAll('[data-product-compare]').forEach(p=>{p.textContent=option.dataset.compare;p.hidden=!option.dataset.compare;});
    buttons().forEach(b=>{b.disabled=!available;b.textContent=available?config.add:config.soldOut;});
    const stock=document.querySelector('[data-stock]');if(stock){stock.textContent=available?config.available:config.soldOut;stock.classList.toggle('bb-stock--out',!available);}
    const url=new URL(location.href);url.searchParams.set('variant',variant.value);history.replaceState({},'',url);
  };
  if(variant)variant.addEventListener('change',updateVariant);
  if(form)form.addEventListener('submit',async event=>{
    event.preventDefault();if(submitting||cartBusy)return;submitting=true;
    const error=form.querySelector('[data-product-error]');if(error)error.hidden=true;
    buttons().forEach(b=>{b.disabled=true;b.textContent=config.adding;});
    try{
      const body=new FormData(form);body.append('sections','bb-footer');body.append('sections_url',config.root);
      const response=await fetch(config.root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body});
      const result=await response.json();if(!response.ok)throw new Error(result.description||result.message||config.error);
      if(!drawer){location.assign(cartUrl);return;}
      try{if(!renderCart(result.sections?.['bb-footer']))await refreshCart();openCart();}catch{location.assign(cartUrl);}
    }catch(problem){if(error){error.textContent=problem.message||config.error;error.hidden=false;error.scrollIntoView({block:'nearest'});}}
    finally{submitting=false;buttons().forEach(b=>{b.disabled=false;b.textContent=config.add;});updateVariant();}
  });
  document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.bb-mobile[open]').forEach(d=>d.open=false);});
})();
